var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNameChangeWrong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 342,
    height: 149
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "name-change-wrong_svg__a",
    x1: "-23.362%",
    x2: "130.472%",
    y1: "63.699%",
    y2: "34.59%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFE380"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "29.042%",
    stopColor: "#FFB480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF8080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "name-change-wrong_svg__b",
    x1: "122.502%",
    x2: "15.362%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF8294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF4057"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "name-change-wrong_svg__c",
    x1: "122.502%",
    x2: "15.362%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF8294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF4057"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDB74",
    d: "M190.864 4.839h11.776c14.534 0-9.799-4.147 0-4.147h53.188c49.62 0 66.313.377 44.699 4.147-21.614 3.77-19.042 1.13 19.801 0 38.843-1.131 20.674 7.785-23.174 7.785-43.849 0-165.972 3.022-142.978 0 15.33-2.014 38.443-3.78 69.341-5.294l-32.653-2.491z",
    opacity: 0.172
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8FCFE",
    d: "M116.474 41.861c-8.494-.25-15.389-1.03-20.684-2.337a5.21 5.21 0 00-7.607-6.938 9.66 9.66 0 00-8.765-5.595 9.66 9.66 0 00-8.827 5.729 5.21 5.21 0 00-8.115 1.673 3.861 3.861 0 00-5.177 2.987c-.484.44-1.047.93-1.687 1.473-2.246 1.906-10.13 2.908-23.656 3.008h84.518z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#name-change-wrong_svg__a)",
    d: "M0 149c2.866-23.566 17.353-35.349 43.46-35.349 39.162 0 42.378-33.404 68.711-46.57 26.333-13.166 36.121 8.689 64.774-10.97 28.653-19.66 49.772-36.498 80.589-21.123C278.079 45.238 281.48 83.242 267.739 149H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(116 19)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F8FCFE",
    d: "M71.767 102H3.233A3.24 3.24 0 010 98.752V3.248A3.24 3.24 0 013.233 0h68.534A3.24 3.24 0 0175 3.248v95.504A3.24 3.24 0 0171.767 102z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.5,
    cy: 33.783,
    fill: "url(#name-change-wrong_svg__b)",
    rx: 20.69,
    ry: 20.79
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M44.06 31.121v1.648c0 3.64-2.937 6.592-6.56 6.592-3.623 0-6.56-2.95-6.56-6.592v-1.648c0-3.64 2.937-6.592 6.56-6.592 3.623 0 6.56 2.952 6.56 6.592z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FABEC8",
    d: "M37.5 39.361c-6.404 0-11.875 3.998-14.087 9.643 3.694 3.454 8.643 5.57 14.087 5.57 5.444 0 10.393-2.116 14.087-5.57-2.212-5.646-7.683-9.643-14.087-9.643z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.207,
    cy: 68.087,
    fill: "url(#name-change-wrong_svg__c)",
    rx: 4.397,
    ry: 4.418
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.207,
    cy: 82.38,
    fill: "url(#name-change-wrong_svg__c)",
    rx: 4.397,
    ry: 4.418
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FABEC8",
    strokeLinecap: "round",
    strokeWidth: 5,
    d: "M30.5 68.087h24m-24 14h24"
  })))));
}
export default SvgNameChangeWrong;